import axios from "axios";

export default {
	cancelSource: null,
	cancelSearch() {
		if (this.cancelSource) {
			this.cancelSource.cancel("Start new search, stop active search");
			//console.log("cancel request done");
		}
	},

	async queryPosts(
		resturl,
		page,
		searchterm,
		postsPerPage,
		route = "spofaq",
		namespace = "wp/v2"
	) {
		try {
			this.cancelSearch();
			this.cancelSource = axios.CancelToken.source();

			/* Note: the per_page argument is capped at 100 records by the REST API.
			 * https://developer.wordpress.org/rest-api/using-the-rest-api/pagination/
			 */
			const fields = "id,title, content, spofaq_category, meta"; // retrieve data for specific fields only.
			const response = await axios(
				`${resturl}/${namespace}/${route}?per_page=${postsPerPage}&page=${page}&orderby=relevance&order=desc&_fields=${fields}&search=${searchterm}`,
				{
					cancelToken: this.cancelSource.token
				}
			);

			// since partial data is already available from this response, make it available.
			const wpPosts = response.data;
			const promises = [];
			for (let page = 2; page <= response.headers["x-wp-totalpages"]; page++) {
				promises.push(
					axios(
						`${resturl}/${namespace}/${route}?per_page=${postsPerPage}&page=${page}&orderby=relevance&order=desc&_fields=${fields}&search=${searchterm}`,
						{
							cancelToken: this.cancelSource.token
						}
					)
				);
			}
			// Await all promises to return before rendering the data.
			const wpData = await Promise.all(promises);

			wpData.map(post => wpPosts.push(...post.data)); // post.data returns an array.
			this.cancelSource = null;
			return wpPosts;
		} catch (error) {
			if (axios.isCancel(error)) {
				//console.error("Request canceled", error.message);
				return null;
			}
			//console.error("API request failed: " + error);
			return null;
		}
	},

	async queryPostsByCategory(
		resturl,
		page,
		searchterm,
		postsPerPage,
		category,
		route = "spofaq",
		namespace = "wp/v2"
	) {
		try {
			this.cancelSearch();
			this.cancelSource = axios.CancelToken.source();
			/* Note: the per_page argument is capped at 100 records by the REST API.
			 * https://developer.wordpress.org/rest-api/using-the-rest-api/pagination/
			 */
			const fields = "id,title, content, spofaq_category, meta"; // retrieve data for specific fields only.
			const response = await axios(
				`${resturl}/${namespace}/${route}?per_page=${postsPerPage}&page=${page}&orderby=relevance&order=desc&_fields=${fields}&search=${searchterm}&spofaq_category=${category}`,
				{
					cancelToken: this.cancelSource.token
				}
			);
			const wpPosts = response.data;

			const promises = [];
			for (let page = 2; page <= response.headers["x-wp-totalpages"]; page++) {
				promises.push(
					axios(
						`${resturl}/${namespace}/${route}?per_page=${postsPerPage}&page=${page}&orderby=relevance&order=desc&_fields=${fields}&search=${searchterm}&spofaq_category=${category}`,
						{
							cancelToken: this.cancelSource.token
						}
					)
				);
			}
			// Await all promises to return before rendering the data.
			const wpData = await Promise.all(promises);
			wpData.map(post => wpPosts.push(...post.data)); // post.data returns an array.
			this.cancelSource = null;
			return wpPosts;
		} catch (error) {
			if (axios.isCancel(error)) {
				//console.error("Request canceled", error.message);
				return null;
			}
			//console.error("API request failed: " + error);
			return null;
		}
	},

	async queryCategories(
		resturl,
		route = "spofaq_category",
		namespace = "wp/v2"
	) {
		try {
			const fields = "id, name";
			return await axios(`${resturl}/${namespace}/${route}?_fields=${fields}&per_page=100&parent=0`);
		} catch (error) {
			//console.error(error);
			return ` The request could not be processed! <br> <strong>${error}</strong> `;
		}
	},

	async queryCategoriesForSearchTerm(
		resturl,
		searchterm,
		route = "spofaq",
		namespace = "wp/v2"
	) {
		try {
			return await axios(
				`${resturl}/${namespace}/${route}?_fields=spofaq_category&search=${searchterm}&per_page=100&parent=0`
			);
		} catch (error) {
			//console.error(error);
			return ` The request could not be processed! <br> <strong>${error}</strong> `;
		}
	}
};
